import successIcon from './img/successIcon.svg';
import { useEffect } from 'react';
import { ButtonBasic, ButtonClose } from '@lk-gtcom/ecomlab-components';
import { TitlePage } from '../../TitlePage/TitlePage';
import { ModalComponent } from '../ModalComponent/ModalComponent';
import './ModalFirstConnection.scss';

const CLOSE_EVENT_TYPE = 'modal first connection close';

const ModalFirstConnection = ({
  setIsServiceConnected,
  setIsServiceSelected,
  onClose
}) => {
  const closeEvent = new Event(CLOSE_EVENT_TYPE);

  useEffect(() => {
    return () => {
      setIsServiceConnected(false);
      setIsServiceSelected(false);
      document.dispatchEvent(closeEvent);
    };
  }, []);

  return (
    <ModalComponent
      onClose={onClose}
      style={{ maxWidth: '600px', height: 'auto' }}
      child={
        <div className="modal-first-connection">
          <img
            src={successIcon}
            className='modal-first-connection__img'
            alt="icon"
          />
          <TitlePage
            title='Подключение создано'
          />
          <p className="modal-first-connection__text">
            Сбор и обработка информации займет <b>до 24 часов.</b>
          </p>
          <p className="modal-first-connection__text">
            Пока мы настраиваем подключение, вы можете ознакомиться с
            <a
              className="modal-first-connection__link-blue"
              style={{
                display: 'block',
                color: '#1890FF',
                cursor: 'pointer',
                userSelect: 'none',
              }}
              onClick={(e) => {
                window.open(
                  'https://wiki.ecomru.ru/main/article/Instruktsija_po_razdelu_%E2%80%9COtzyvy_i_voprosy%E2%80%9D_na_Ecomru.ru/735',
                  '_blank'
                );
              }}
            >
              инструкцией по разделу.
            </a>
          </p>

          <ButtonBasic
            text="Новое подключение"
            green
            size="56px"
            onClick={(e) => {
              setIsServiceConnected(false);
              setIsServiceSelected(false);
            }}
          />
        </div>
      }
    />
  );
};

export { ModalFirstConnection, CLOSE_EVENT_TYPE };
